"use strict";

exports.__esModule = true;
exports.ComponentSize = void 0;
var _react = _interopRequireWildcard(require("react"));
var _elementResizeDetector = _interopRequireDefault(require("element-resize-detector"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); } /* eslint-disable react/no-find-dom-node */
var ComponentSize = exports.ComponentSize = /*#__PURE__*/function (_Component) {
  function ComponentSize(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      initiated: false,
      dimensions: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: 0,
        height: 0
      }
    };
    _this.ref = null;
    _this.parentNode = null;
    _this.elementResizeDetector = null;
    _this.componentIsMounted = null;
    _this.onResize = function () {
      var clientRect = ComponentSize.getDomNodeDimensions(_this.parentNode);
      if (_this.componentIsMounted) {
        _this.setState({
          initiated: true,
          dimensions: clientRect
        });
      }
    };
    _this.ref = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _inheritsLoose(ComponentSize, _Component);
  ComponentSize.getDomNodeDimensions = function getDomNodeDimensions(node) {
    if (node) {
      var _node$getBoundingClie = node.getBoundingClientRect(),
        top = _node$getBoundingClie.top,
        right = _node$getBoundingClie.right,
        bottom = _node$getBoundingClie.bottom,
        left = _node$getBoundingClie.left,
        width = _node$getBoundingClie.width,
        height = _node$getBoundingClie.height;
      return {
        top: Math.floor(top),
        right: Math.floor(right),
        bottom: Math.floor(bottom),
        left: Math.floor(left),
        width: Math.floor(width),
        height: Math.floor(height)
      };
    }
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      width: 0,
      height: 0
    };
  };
  var _proto = ComponentSize.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var node = this.ref.current;
    if (node) {
      this.parentNode = node.parentNode;
      this.elementResizeDetector = (0, _elementResizeDetector["default"])({
        strategy: "scroll",
        callOnAdd: false
      });
      this.elementResizeDetector.listenTo(this.parentNode, this.onResize);
      this.componentIsMounted = true;
      this.onResize();
    } else {
      throw new Error("Unable to find dome node when using ComponentSize");
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.componentIsMounted = false;
    if (this.parentNode && this.elementResizeDetector) {
      this.elementResizeDetector.uninstall(this.parentNode);
    }
  };
  _proto.render = function render() {
    var children = this.props.children;
    var _this$state = this.state,
      initiated = _this$state.initiated,
      dimensions = _this$state.dimensions;
    if (!initiated) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      });
    }
    return children(dimensions);
  };
  return ComponentSize;
}(_react.Component);